import { jsx as r } from "react/jsx-runtime";
import { twJoin as o } from "tailwind-merge";
import { useDesignContext as m } from "../../providers/use-design-provider.mjs";
const a = ({ text: t }) => {
  const { isDefaultTheme: e } = m();
  return /* @__PURE__ */ r(
    "h2",
    {
      className: o(
        "w-full max-w-xl px-5 py-2.5 text-2xl font-bold sm:px-0",
        e ? "text-text-primary" : "text-THEME-primary"
      ),
      children: t
    }
  );
};
export {
  a as default
};
